import React, { Component } from 'react';
import { connect } from 'react-redux';

import { evAddPaymentInstrumentClick } from 'events/account';

import { deletePaymentInfo, fetchPaymentInfo, makePrimary } from 'actions/account/payment';
import { checkCustomerAuthentication } from 'actions/authentication';
import { firePixelServer } from 'actions/pixelServer';
import PaymentCardLayout from 'components/account/PaymentCardLayout';
import SiteAwareMetadata from 'components/SiteAwareMetadata';
import AccountHeader from 'containers/account/AccountHeader';
import Breadcrumb from 'components/account/Breadcrumb';
import BackNav from 'components/account/BackNav';
import { PageLoader } from 'components/Loader';
import { titaniteView, track } from 'apis/amethyst';
import styles from 'styles/containers/account/payments.scss';

const items = [{ name: 'Payment Information' }];

export class Payments extends Component {
  componentDidMount() {
    titaniteView();

    const { firePixelServer, checkCustomerAuthentication } = this.props;
    const returnTo = '/payments';

    checkCustomerAuthentication(returnTo, () => this.fetchData());
    firePixelServer('my-account', {}, 'payment-list');
  }

  fetchData() {
    const { payment: { paymentInstruments }, fetchPaymentInfo } = this.props;

    if (!paymentInstruments) {
      fetchPaymentInfo(null, '/payments');
    }
  }

  handleAddNewPayment = () => {
    track(evAddPaymentInstrumentClick, { sourcePage: 7 });
  };

  handleDelete = ({ paymentInstrumentId }, win = window) => {
    const { deletePaymentInfo } = this.props;
    deletePaymentInfo(paymentInstrumentId);
    win.scrollTo(0, 0);
  };

  handleMakePrimary = ({ fullName, paymentInstrumentId }, win = window) => {
    const { makePrimary } = this.props;
    makePrimary(fullName, paymentInstrumentId);
    win.scrollTo(0, 0);
  };

  render() {
    const { payment: { paymentInstruments, isLoading } } = this.props;

    if (!paymentInstruments || isLoading) {
      return <PageLoader centered={true}/>;
    }

    return (
      <SiteAwareMetadata>
        <div className={styles.payments}>
          <div className={styles.header}>
            <Breadcrumb items={items}/>
            <BackNav to="/account">My Account</BackNav>
            <AccountHeader title="Payment Information"/>
          </div>
          <PaymentCardLayout
            paymentInstruments={paymentInstruments}
            onPrimary={this.handleMakePrimary}
            onDelete={this.handleDelete}
            onAddNewPayment={this.handleAddNewPayment} />
        </div>
      </SiteAwareMetadata>
    );
  }
}

const mapStateToProps = state => ({
  payment: state.payment
});

export default connect(mapStateToProps, {
  fetchPaymentInfo,
  firePixelServer,
  deletePaymentInfo,
  makePrimary,
  checkCustomerAuthentication
})(Payments);
